import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';
import ContentContainer from "../ReusableComponents/ContentContainer/ContentContainer"
import PanelSection from "../ReusableComponents/PanelSection/PanelSection"
import usePageHead from '../../hooks/usePageHead';

const NotFoundPage = () => {
  // public/index.html carries the homepage head; this page must not inherit it.
  usePageHead({ title: '404 — Page Not Found | EvolveBay', canonical: null });

  return (
    <ContentContainer>
      <div className={styles.NotFoundPage} data-testid="NotFoundPage">
        <PanelSection shadow={false}>
          <div className={styles.notFound}>404 Not Found</div>
          <p className={styles.notFoundHelp}>
            That page doesn't exist. <Link to="/">Go back to the homepage</Link>{' '}
            or <Link to="/#contact">get in touch</Link>.
          </p>
        </PanelSection>
      </div>
    </ContentContainer>
  );
};

export default NotFoundPage;
